import { render } from "./SampleDatabaseUpload.vue?vue&type=template&id=29ead09a"
import script from "./SampleDatabaseUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleDatabaseUpload.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Common/Media/SampleDatabaseUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29ead09a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29ead09a', __exports__)) {
    api.reload('29ead09a', __exports__)
  }
  
  module.hot.accept("./SampleDatabaseUpload.vue?vue&type=template&id=29ead09a", () => {
    api.rerender('29ead09a', render)
  })

}


export default __exports__